<div class="grid__table d-flex flex-column flex-grow-1 mb-6">
  <table class="table note">
    <thead>
      <tr>
        @for (col of dataSource.columns; track trackByColumns($index, col)) {
          <th [ngClass]="'grid-column-' + col.name">
            <gcc-grid-header-cell
              [column]="col"
              [sortBy]="queryParams.sortBy"
              [sortDirection]="queryParams.descending ? sortDirections.Descending : sortDirections.Ascending"
              [filterValue]="queryParams.filters[col.name]"
              (apply)="onApply(col.name, $event)"
            ></gcc-grid-header-cell>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @for (item of items; track trackByItems($index, item)) {
        <tr>
          @for (col of dataSource.columns; track trackByColumns($index, col)) {
            <td [ngClass]="col.mapClassFn(item) + ' grid-column-' + col.name" [class.text-right]="col.alignToRight">
              <gcc-grid-cell [column]="col" [item]="item"></gcc-grid-cell>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
  @if (!isLoading && !items.length) {
    <ng-content></ng-content>
  }
</div>

<div class="grid__pagination d-flex align-items-center">
  <div class="note">Page</div>
  <pagination
    class="flex-grow-1 mb-0"
    [boundaryLinks]="true"
    [totalItems]="totalCount"
    [itemsPerPage]="queryParams.pageSize"
    (pageChanged)="onPageChange($event)"
    [maxSize]="7"
    previousText="&lsaquo;"
    nextText="&rsaquo;"
    firstText="&laquo;"
    lastText="&raquo;"
  >
  </pagination>
  <div class="note mr-4">
    {{ (queryParams.pageNumber - 1) * queryParams.pageSize + 1 }} -
    {{
      queryParams.pageNumber * queryParams.pageSize < totalCount
        ? queryParams.pageNumber * queryParams.pageSize
        : totalCount
    }}
    of
    <span class="bold">{{ totalCount }}</span>
  </div>
  <div class="btn-group dropdown" bsDropdown [dropup]="true" placement="top">
    <button dropdownToggle type="button" class="btn btn-light dropdown-toggle">
      {{ queryParams.pageSize }}
    </button>
    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right note" role="menu">
      @for (opt of pageSizeOptions; track opt) {
        <li role="menuitem">
          <a class="dropdown-item py-1 px-4" href="javascrit:void(0)" (click)="onPageSizeChange(opt)">{{ opt }}</a>
        </li>
      }
    </ul>
  </div>
</div>
